module.exports = __webpack_public_path__ + "static/img/coupons_goods_mini.713ebe4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/coupons_goods_mini.png
// module id = XFgO
// module chunks = 1